export const FORM_NAME_MAX_LENGTH = 100;
export const FORM_TEMPLATE_EDITOR_NO_BLOCK_LIMIT = -1;

export const FORM_POPUP_MIN_DELAY = 0;
export const FORM_POPUP_DEFAULT_DELAY = 1;
export const FORM_POPUP_MAX_DELAY = 10000;